import { createContext } from 'react';

export const ClientsContext = createContext();
